import type * as React from "react";
import { IMaskInput } from "react-imask";

type CustomProps = {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
};

function PhoneMask({
  ref,
  ...props
}: CustomProps & { ref?: React.RefObject<HTMLInputElement | null> }) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      radix="."
      mask=" 0 00 00 00 00"
      definitions={{
        0: /\d/,
      }}
      inputRef={ref}
      onAccept={(value: any) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
}

function IbanMask({
  ref,
  ...props
}: CustomProps & { ref?: React.RefObject<HTMLInputElement | null> }) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="FR00 0000 0000 0000 0000 0000 000"
      definitions={{
        F: "F",
        R: "R",
        0: /[0-9,A-Z]/,
      }}
      inputRef={ref}
      onAccept={(value: any) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
}

function formatPhoneNumber(value: any) {
  return value?.replace(/(.{3})/g, "$1 ");
}

export { formatPhoneNumber, IbanMask, PhoneMask };
